import { ErrorBoundary } from '@sentry/react'

import { DefaultFallback, IDefaultFallbackProps } from './Fallbacks'
import { useLocation } from 'react-router-dom'

interface IGenericErrorBoundaryProps extends IDefaultFallbackProps {
  fallback?: ErrorBoundary['props']['fallback']
}

export const GenericErrorBoundary = (
  props: React.PropsWithChildren<IGenericErrorBoundaryProps>
) => {
  const location = useLocation();
  
  return (
    <ErrorBoundary
      key={location.pathname}
      fallback={props.fallback ?? <DefaultFallback {...props} />}
    >
      {props.children}
    </ErrorBoundary>
  );
}

export default GenericErrorBoundary
